// extracted by mini-css-extract-plugin
export var dividerContainer = "_9y-0";
export var line = "_9y-1";